// extracted by mini-css-extract-plugin
module.exports = {"tabItem":"tabUrl_tabItem__cFmv2","tabItemSelected":"tabUrl_tabItemSelected__3e86B"};